
const ProtetskiRad = function(DS) {
    return DS.defineResource({
        name: 'ProtetskiRad',
        endpoint: '/protetskiRadovi'
    });
};

ProtetskiRad.$inject = ['DS'];


export {ProtetskiRad};



// WEBPACK FOOTER //
// ./app/models/protetskiRad.js